import api from '@shared/services/api';

export const personHolidaysService = {
    getTypeAOptions: async (absence = 'PAYL') => {
        const response = await api.get('/type-a', { params: { absence } });
        return response.data;
    },
    getRightFullHolidays: async (empId, contractId) => {
        const response = await api.get('/right-full-holidays', {
            params: { empId, contractId }
        });
        return response.data;
    },
    getRightFullHolidayById: async (id) => {
        const response = await api.get(`/right-full-holidays/${id}`);
        return response.data;
    },
    createRightFullHoliday: async (data) => {
        const response = await api.post('/right-full-holidays', data);
        return response.data;
    },
    updateRightFullHoliday: async (id, data) => {
        const response = await api.put(`/right-full-holidays/${id}`, data);
        return response.data;
    },
    deleteRightFullHoliday: async (id) => {
        const response = await api.delete(`/right-full-holidays/${id}`);
        return response.data;
    }
};